// extracted by mini-css-extract-plugin
export default {"ItemOuter":"UserItems_ItemOuter__3NAa0"};